/** Progressive enhancement for the 0901 navigation; Shopify owns search and cart. */
class YeadayNavigation extends HTMLElement {
  connectedCallback() {
    this.abortController?.abort();
    this.abortController = new AbortController();
    const { signal } = this.abortController;
    this.toggle = this.querySelector('[data-menu-toggle]');
    this.navigation = this.querySelector('.yeaday-header__navigation');
    this.openLabel = this.toggle?.dataset.openLabel;
    this.setOpen(false);
    this.mobile = window.matchMedia('(max-width: 1199px)');
    this.setAttribute('data-enhanced', '');
    this.toggle?.addEventListener('click', () => this.setOpen(!this.hasAttribute('data-menu-open')), { signal });
    this.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      const item = event.target.closest('details[open]');
      if (item) {
        item.open = false;
        item.querySelector('summary')?.focus();
      } else if (this.hasAttribute('data-menu-open')) {
        this.setOpen(false);
        this.toggle?.focus();
      }
    }, { signal });
    this.querySelectorAll('.yeaday-menu__item').forEach((item) => {
      item.addEventListener('toggle', () => {
        if (!item.open) return;
        this.querySelectorAll('.yeaday-menu__item').forEach((other) => { if (other !== item) other.open = false; });
      }, { signal });
    });
    document.addEventListener('click', (event) => {
      if (!this.contains(event.target)) this.close();
    }, { signal });
    this.addEventListener('focusout', (event) => {
      if (event.relatedTarget && !this.contains(event.relatedTarget)) this.close();
    }, { signal });
    this.mobile.addEventListener('change', () => this.close(), { signal });
    this.navigation?.addEventListener('click', (event) => {
      if (event.target.closest('a[href]')) this.close();
    }, { signal });
    this.resizeObserver = new ResizeObserver(() => {
      document.body.style.setProperty('--header-height', `${this.offsetHeight}px`);
      document.body.style.setProperty('--header-group-height', `${this.offsetHeight}px`);
    });
    this.resizeObserver.observe(this);
    const scrollRoot = this.closest('.page-wrapper');
    const updateCompact = () => {
      if (this.querySelector('details[open]') || this.hasAttribute('data-menu-open') || this.contains(document.activeElement)) return;
      const y = Math.max(window.scrollY, scrollRoot?.scrollTop || 0);
      if (this.mobile.matches || y < 40) this.removeAttribute('data-compact');
      else if (y > 280) this.setAttribute('data-compact', '');
    };
    (scrollRoot || window).addEventListener('scroll', updateCompact, { signal, passive: true });
    this.mobile.addEventListener('change', updateCompact, { signal });
    updateCompact();

  }
  setOpen(open) {
    this.toggleAttribute('data-menu-open', open);
    this.toggle?.setAttribute('aria-expanded', String(open));
    this.toggle?.setAttribute('aria-label', open ? this.toggle.dataset.closeLabel : this.openLabel);
  }
  close() {
    this.setOpen(false);
    this.querySelectorAll('details[open]').forEach((item) => { item.open = false; });
  }
  disconnectedCallback() {
    this.abortController?.abort();
    this.resizeObserver?.disconnect();
  }
}
if (!customElements.get('yeaday-navigation')) customElements.define('yeaday-navigation', YeadayNavigation);
